import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Button, TextArea} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import './reject.scss';

class GenerateTxtModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
      'description': '',
    };
    this.onRejectClick = this.onRejectClick.bind(this);
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.onChangeTextField = this.onChangeTextField.bind(this);
  }

  onChangeTextField(event) {
    const value = event.target.value;
    this.setState({'description': value});
  }

  fetchData() {
    this.setState({'modalWasOpen': true});
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false, 'description': ''});
  }

  onRejectClick() {
    const {index, dealer, orderSequence} = this.props;
    const {description} = this.state;

    const data = {
      'status': 'N',
      'orderSequence': orderSequence,
      'rejectReason': description,
      'dealer': dealer,
    };
    this.props.rejectProviderSpecialOrder(index, data);
    this.onCloseModalClick();
  }

  render() {
    const {modalWasOpen, description} = this.state;
    const {orderSequence, disabled} = this.props;
    return (
      <Modal size='small' onOpen={() => this.fetchData()}
        className='reject-providers-special-order-modal'
        open={modalWasOpen}
        trigger={
          <Button secondary
            size='mini'
            disabled={disabled}
          >
            Negar
          </Button>
        }>

        <Modal.Header>
          Negar pedido {orderSequence}
        </Modal.Header>
        
        <Modal.Content scrolling>
          <Modal.Description>
            <div>
              <strong>Ingrese una razón para negar este pedido:</strong>
            </div>
            <TextArea
              rows={5}
              value={description}
              onChange={this.onChangeTextField}
              autoComplete='off'
              placeholder='Ingrese una razón'
            />
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick}>
            Cancelar
          </Button>
          <Button positive
            disabled={!description}
            onClick={this.onRejectClick}>
            Aceptar
          </Button>
        </Modal.Actions>

      </Modal>
    );
  }
}

const {
  rejectProviderSpecialOrder,
} = Actions;

export default connect(null, {
  rejectProviderSpecialOrder,
})(GenerateTxtModal);
